export default "__VITE_ASSET__vckIvbVV__"